<template>
  <div>
    <PageTitle title="Hacker News: Ask" />
    <PostList source="https://hacker-news.firebaseio.com/v0/askstories.json"/>
  </div>
</template>

<script>
import PostList from '@/components/PostList'
import PageTitle from '@/components/PageTitle'
export default {
  name: 'Ask',
  components: {
    PageTitle,
    PostList
  }
}
</script>
